import { LockClosedIcon } from '@heroicons/react/24/outline';
import { forwardRef, type ReactNode } from 'react';

interface UDInputProps {
    value: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    locked?: boolean;
    type?: string;
    autoFocus?: boolean;
    icon?: ReactNode;
}

// Real controlled input styled after the mock's UDInput - `locked` renders a
// read-only, greyed field with a lock icon (used for email on edit).
export const UDInput = forwardRef<HTMLInputElement, UDInputProps>(function UDInput(
    { value, onChange, placeholder, locked, type = 'text', autoFocus, icon },
    ref
) {
    return (
        <span
            className={`h-10 border rounded-lg px-3 flex items-center gap-2 ${
                locked
                    ? 'bg-gray-50 border-gray-200'
                    : 'bg-white border-gray-300 focus-within:border-gray-800 focus-within:ring-2 focus-within:ring-gray-200'
            }`}
        >
            {icon && <span className="text-gray-400 shrink-0">{icon}</span>}
            <input
                ref={ref}
                type={type}
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                placeholder={placeholder}
                readOnly={locked}
                autoFocus={autoFocus}
                className={`flex-1 min-w-0 text-sm outline-none bg-transparent ${
                    locked
                        ? 'text-gray-500 cursor-not-allowed'
                        : 'text-gray-800 placeholder-gray-400'
                }`}
            />
            {locked && <LockClosedIcon className="h-3.5 w-3.5 text-gray-400 shrink-0" />}
        </span>
    );
});
